var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.977 8.766a.5.5 0 00-.148-.352L7.415 7l1.414-1.414c.094-.094.148-.219.148-.352s-.055-.266-.148-.359l-.703-.703a.503.503 0 00-.711 0L6.001 5.586 4.587 4.172c-.094-.094-.219-.148-.352-.148s-.266.055-.359.148l-.703.703a.503.503 0 000 .711L4.587 7 3.173 8.414c-.094.094-.148.219-.148.352s.055.266.148.359l.703.703a.503.503 0 00.711 0l1.414-1.414 1.414 1.414c.094.094.219.148.352.148s.266-.055.359-.148l.703-.703a.515.515 0 00.148-.359zM12 7A6 6 0 010 7a6 6 0 0112 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXFilled);
export default __webpack_public_path__ + "static/media/CircleXFilled.be152592a936b1c39e2e18cd34f03acc.svg";
export { ForwardRef as ReactComponent };